import type {
  BackupRecord,
  BackupStorage,
  SerializedEditorStateJson,
} from "./types.js";

const CURRENT_KEY = "tgpe:current";
const ACTIVE_DRAFT_KEY = "tgpe:active_draft_id";

export class LocalStorageBackup implements BackupStorage {
  saveCurrent(state: SerializedEditorStateJson): void {
    const payload: BackupRecord = {
      state,
      saved_at: new Date().toISOString(),
    };
    const serialized = JSON.stringify(payload);
    try {
      localStorage.setItem(CURRENT_KEY, serialized);
    } catch {
      // Quota exceeded — clear and retry once. Backup is best-effort.
      localStorage.removeItem(CURRENT_KEY);
      try {
        localStorage.setItem(CURRENT_KEY, serialized);
      } catch {
        /* give up silently */
      }
    }
  }

  loadCurrent(): BackupRecord | null {
    const raw = localStorage.getItem(CURRENT_KEY);
    if (!raw) return null;
    try {
      const parsed: unknown = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") return null;
      const obj = parsed as Partial<BackupRecord>;
      if (typeof obj.saved_at !== "string" || obj.state == null) return null;
      return { state: obj.state, saved_at: obj.saved_at };
    } catch {
      return null;
    }
  }

  clearCurrent(): void {
    localStorage.removeItem(CURRENT_KEY);
  }
}

export const activeDraftIdStorage = {
  get(): string | null {
    return localStorage.getItem(ACTIVE_DRAFT_KEY);
  },
  set(id: string | null): void {
    if (id === null) localStorage.removeItem(ACTIVE_DRAFT_KEY);
    else localStorage.setItem(ACTIVE_DRAFT_KEY, id);
  },
};
